import { API_BASE_URL } from "../urls.api";

export const GET_MONITORING_BETWEEN_RANGE_BY_MONITOR_ID = `${API_BASE_URL}/monitors`;

export const GET_ENVIRONMENT_BETWEEN_RANGE_BY_MONITOR_ID = `${API_BASE_URL}/monitors/environment`;

export const GET_SMOKING_PROBABILITY = `${API_BASE_URL}/monitors/smokingProbability`;

export const GET_PAX_BUCKET_BETWEEN_RANGE_BY_MONITOR_ID = `${API_BASE_URL}/monitors/pax`;
